import MuseumsManager from "./MuseumsManager";
export default function Museums() { return <MuseumsManager kind="museum" />; }
